import { LicenseRequest } from "./models";
import moment from "moment";

interface Placeholder {
  text: string;
  placeholder: string;
  song?: boolean;
  master?: boolean;
  region?: string;
  getReplaceText: (arg0: LicenseRequest) => string;
  shouldReplaceSpans?: boolean;
}

const integritySignatureImageBase64 =
  "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";

const signatureUnderscore = "__________________";

const getDateFormat = (licenseRequest: LicenseRequest, date: Date) => {
  const region = licenseRequest.user.region;
  const dateFormat = region === "US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
  const formattedDate = moment(date).format(dateFormat);
  return formattedDate;
};

const placeholders: { [key: string]: Array<Placeholder> } = {
  licensee: [
    {
      text: "Organization Name",
      placeholder: "ORGANIZATION.NAME",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.name
    },
    {
      text: "Contact Name",
      placeholder: "ORG.CONTACT.NAME",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.firstName + " " + licenseRequest.user.lastName
    },
    {
      text: "Org Address 1",
      placeholder: "ORGANIZATION.ADDRESS1",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.address1
    },
    {
      text: "Org Address 2",
      placeholder: "ORGANIZATION.ADDRESS2",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.address2
    },
    {
      text: "Org City",
      placeholder: "ORGANIZATION.CITY",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.city,
      region: "US"
    },
    {
      text: "Org State",
      placeholder: "ORGANIZATION.STATE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.state,
      region: "US"
    },
    {
      text: "Org Zip",
      placeholder: "ORGANIZATION.ZIP",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.zip,
      region: "US"
    },
    {
      text: "Org Town",
      placeholder: "ORGANIZATION.TOWN",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.town,
      region: "UK"
    },
    {
      text: "Org County",
      placeholder: "ORGANIZATION.COUNTY",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.county,
      region: "UK"
    },
    {
      text: "Org Postcode",
      placeholder: "ORGANIZATION.POSTCODE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.user.organization.postcode,
      region: "UK"
    }
  ],
  license: [
    {
      text: "License Number",
      placeholder: "LICENSE.NUMBER",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.id.toString()
    },
    {
      text: "Customer Signature",
      placeholder: "LICENSE.CUSTOMER_SIGNATURE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.signedByUser
          ? `<span style="font-family: 'Helve Cursive', cursive; font-size: 14pt">${licenseRequest
              .user.firstName} ${licenseRequest.user.lastName}</span>`
          : signatureUnderscore,
      shouldReplaceSpans: true
    },
    {
      text: "Customer Signature Date",
      placeholder: "LICENSE.CUSTOMER_SIGNATURE_DATE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.signedByUserDate
          ? `${getDateFormat(licenseRequest, licenseRequest.signedByUserDate)}`
          : "",
      shouldReplaceSpans: true
    },
    {
      text: "Integrity Signature",
      placeholder: "LICENSE.INTEGRITY_SIGNATURE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.signedByIntegrity
          ? `<span data-span-type="admin-signature">
					<img src="data:image/jpeg;charset=utf-8;base64,${integritySignatureImageBase64}" style="height: 60px; width: 90px" alt="admin-signature" />
					<br />
					<span style="margin-left: 20px">Jonathan Lane</span>
					<br />
					<span style="margin-left: 20px">Senior Director of Music Administration And Contracts</span>
        </span>`
          : signatureUnderscore,
      shouldReplaceSpans: true
    },
    {
      text: "Integrity Signature Date",
      placeholder: "LICENSE.INTEGRITY_SIGNATURE_DATE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.signedByIntegrityDate
          ? `${getDateFormat(
              licenseRequest,
              licenseRequest.signedByIntegrityDate
            )}`
          : "",
      shouldReplaceSpans: true
    },
    {
      text: "Order Complete Date",
      placeholder: "LICENSE.ORDER_COMPLETE_DATE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.completedDate
          ? `${getDateFormat(licenseRequest, licenseRequest.completedDate)}`
          : "",
      shouldReplaceSpans: true
    },
    {
      text: "Order Paid Date",
      placeholder: "LICENSE.ORDER_PAID_DATE",
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.completedDate
          ? `${getDateFormat(licenseRequest, licenseRequest.completedDate)}`
          : "",
      shouldReplaceSpans: true
    }
  ],
  product: [
    {
      text: "Title",
      placeholder: "PRODUCT.TITLE",
      song: true,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.title
    },
    {
      text: "Openplay ID",
      placeholder: "PRODUCT.OPENPLAYID",
      song: false,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.openPlayId
    },
    {
      text: "Music Maestro ID",
      placeholder: "PRODUCT.MUSICMAESTROID",
      song: true,
      master: false,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.musicMaestroId
    },
    {
      text: "Songwriter(s)",
      placeholder: "PRODUCT.SONGWRITERS",
      song: true,
      master: false,
      getReplaceText: (licenseRequest: LicenseRequest) => {
        return Object.entries(licenseRequest.work)
          .sort((a, b) => (a[0] > b[0] ? 1 : -1))
          .filter(
            e =>
              e[0].substring(0, 6) === "writer" &&
              e[0].substring(e[0].length - 10) !== "Percentage" &&
              e[1]
          )
          .map(e => e[1])
          .join(", ");
      }
    },
    {
      text: "Track Artist Name",
      placeholder: "PRODUCT.TRACKARTISTNAME",
      song: false,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.trackArtistName
    },
    {
      text: "Album Name",
      placeholder: "PRODUCT.ALBUMNAME",
      song: false,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.albumName
    },
    {
      text: "Release Artist Name",
      placeholder: "PRODUCT.RELEASEARTISTNAME",
      song: false,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.releaseArtistName
    },
    {
      text: "Song Version",
      placeholder: "PRODUCT.SONGVERSION",
      song: false,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.songVersion
    },
    {
      text: "CCLI Number",
      placeholder: "PRODUCT.CCLINUMBER",
      song: true,
      master: false,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.ccliNumber
    },
    {
      text: "Copyright Notice",
      placeholder: "PRODUCT.COPYRIGHTNOTICE",
      song: true,
      master: false,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.copyrightNotice
    },
    {
      text: "Integrity Music % Control",
      placeholder: "PRODUCT.TOTALIMPERCENTCONTROL",
      song: true,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.totalImPercentControl
    },
    {
      text: "ISRC Number",
      placeholder: "PRODUCT.ISRCNUMBER",
      song: false,
      master: true,
      getReplaceText: (licenseRequest: LicenseRequest) =>
        licenseRequest.work.isrcNumber
    }
  ]
};

export { placeholders };
